module.exports = __webpack_public_path__ + "img/threshold-off.247aec9a.svg";